module.exports = __webpack_public_path__ + "img/user01.441343cc.jpg";